import * as Sentry from '@sentry/angular';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from '@env/environment';

Sentry.init({
    dsn: 'https://d5607ed44d0e461d0ee49cdb90c49e0b@o4510864153837568.ingest.us.sentry.io/4511090452660224',
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
    enableLogs: true,
    sendDefaultPii: true,
    environment: environment.sentryEnv,
});

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
